const C = require("../constants");

const clientDialog = (data) => {
    return {
        type: C.CLIENT_DIALOG,
        data
    }
};

export {clientDialog};


// WEBPACK FOOTER //
// ./src/actions/ClientDialogAction.js